import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "actions" },
            [
              !_vm.view
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { outlined: "", dense: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addRowPermission()
                        },
                      },
                    },
                    [_vm._v(_vm._s("Agregar Permiso"))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VForm,
        { ref: "form_permission", attrs: { id: "form_permission" } },
        [
          _c(VDataTable, {
            key: _vm.key_table,
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers_permissions,
              items: _vm.filteredItems,
              "hide-default-footer": "",
              "items-per-page": _vm.pagination_permissions.limit,
              page: _vm.pagination_permissions.current,
            },
            on: {
              pagination: function ($event) {
                _vm.pagination_permissions.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination_permissions, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.email",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    !item.new
                      ? _c("span", [_vm._v(_vm._s(item.email))])
                      : _vm._e(),
                    item.new
                      ? _c(VTextField, {
                          attrs: {
                            small: "",
                            dense: "",
                            outlined: "",
                            "hide-details": "auto",
                            rules: _vm.rules.email,
                          },
                          model: {
                            value: item.email,
                            callback: function ($$v) {
                              _vm.$set(item, "email", $$v)
                            },
                            expression: "item.email",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "item.owner",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(VCheckbox, {
                      attrs: {
                        small: "",
                        dense: "",
                        disabled: "",
                        "hide-details": "auto",
                      },
                      model: {
                        value: item.owner,
                        callback: function ($$v) {
                          _vm.$set(item, "owner", $$v)
                        },
                        expression: "item.owner",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.administrator",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(VCheckbox, {
                      attrs: { small: "", dense: "", "hide-details": "auto" },
                      model: {
                        value: item.administrator,
                        callback: function ($$v) {
                          _vm.$set(item, "administrator", $$v)
                        },
                        expression: "item.administrator",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.view_permission",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(VCheckbox, {
                      attrs: {
                        small: "",
                        dense: "",
                        disabled: "",
                        "input-value": true,
                        "hide-details": "auto",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.edit_permission",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(VCheckbox, {
                      attrs: {
                        small: "",
                        dense: "",
                        disabled: _vm.view,
                        "hide-details": "auto",
                      },
                      model: {
                        value: item.edit_permission,
                        callback: function ($$v) {
                          _vm.$set(item, "edit_permission", $$v)
                        },
                        expression: "item.edit_permission",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.delete_permission",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(VCheckbox, {
                      attrs: {
                        small: "",
                        dense: "",
                        disabled: _vm.view,
                        "hide-details": "auto",
                      },
                      model: {
                        value: item.delete_permission,
                        callback: function ($$v) {
                          _vm.$set(item, "delete_permission", $$v)
                        },
                        expression: "item.delete_permission",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    !_vm.view
                      ? _c(
                          VBtn,
                          {
                            staticClass: "btn-icon-inca",
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deletePermissions(item)
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("icon-delete"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("pagination-vue", {
            attrs: { pagination: _vm.pagination_permissions },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }